import React from "react";
import MainScreen from "./screens/MainScreen";

const App = () => {
    return (
        <MainScreen/>
    );
};

export default App;
